import { useCallback } from 'react';
import { usePanels } from '../../../../panels/usePanels';
import { dependenciesPanelType, DependenciesPanelData } from './dependenciesPanelType';

export const useDependenciesPanel = () => {
  const { maybeOpenPanel } = usePanels();

  const openDependenciesPanel = useCallback(
    ({
      metadataElementId,
      crmOrgId,
      color,
    }: {
      metadataElementId: string;
      crmOrgId: string;
      color?: string;
    }) => {
      const data: DependenciesPanelData = {
        metadataElementId,
        crmOrgId,
        color,
      };

      maybeOpenPanel({
        panelType: dependenciesPanelType,
        data,
      });
    },
    [maybeOpenPanel],
  );

  return {
    openDependenciesPanel,
  };
};
